import * as ReactTable from 'react-table';

import { Column, UseTableHooks, UseTableInstance, UseTableOptions } from './tableHooks.models';

import CheckboxWithoutLabel from '@trackman/web-shared-components/components/Checkbox/CheckboxWithoutLabel';
import React from 'react';

const useCheckbox =
  (options: { enable: boolean }) =>
  (hooks: UseTableHooks): void => {
    if (options.enable) {
      hooks.visibleColumns.push((columns) => [
        {
          id: '__selection__',
          disableResizing: true,
          align: 'center',
          width: 50,

          Header: ({ getToggleAllRowsSelectedProps }: any) => {
            return React.createElement(CheckboxWithoutLabel, {
              ...getToggleAllRowsSelectedProps(),
              indeterminate: false,
            });
          },

          Cell: ({ row }: any) => React.createElement(CheckboxWithoutLabel, row.getToggleRowSelectedProps()),
        },
        ...columns,
      ]);
    }
  };

const useTable = (props: UseTableOptions, ...pluginHooks: Array<(hooks: UseTableHooks) => void>): UseTableInstance => {
  const { initialState, ...rest } = props;
  return ReactTable.useTable(
    {
      ...rest,
      initialState: {
        hiddenColumns: rest.columns.filter((column: Column) => column.hidden).map((column) => column.id),
        ...initialState,
      },
    } as any,
    ...pluginHooks
  ) as any;
};

export const tableHooks = { ...ReactTable, useCheckbox, useTable };
